import type { NavSection } from '@ltvco/refresh-lib/deepsearch';

export const REPORT_NAV_CONFIG: Partial<Record<string, NavSection[]>> = {
  person: [
    {
      label: 'Contact Information',
      href: '#phone-numbers-section',
      children: [
        { label: 'Phone Numbers', href: '#phone-numbers-section' },
        { label: 'Email Addresses', href: '#email-section' },
        { label: 'Address History', href: '#address-history-section' },
        { label: 'Social Media', href: '#possible-social-media' },
        { label: 'Usernames', href: '#possible-usernames' },
      ],
    },
    { label: 'Names & Ancestry', href: '#names-ancestry-section' },
    { label: 'Possible Relatives', href: '#relatives-section' },
    { label: 'Marital Records', href: '#marital-records-section' },
    { label: 'Associates', href: '#associates-section' },
    { label: 'Neighbors', href: '#neighbors-section' },
    { label: 'Criminal or Traffic', href: '#criminal-or-traffic-section' },
    { label: 'Jobs', href: '#jobs-section' },
    { label: 'Education', href: '#education-section' },
    { label: 'Assets', href: '#possible-owned-assets-section' },
    { label: 'Related Reports', href: '#related-reports-section' },
  ],
  phone: [
    {
      label: 'Potential Owners',
      href: '#potential-owners-section',
      children: [
        { label: 'Phone Numbers', href: '#phone-numbers-section' },
        { label: 'Email Addresses', href: '#email-section' },
        { label: 'Address History', href: '#address-history-section' },
        { label: 'Social Media', href: '#social-media-section' },
        { label: 'Jobs', href: '#jobs-section' },
        { label: 'Education', href: '#education-section' },
        { label: 'Assets', href: '#possible-owned-assets-section' },
      ],
    },
    { label: 'FraudScan Summary', href: '#phone-fraudscan-section' },
    { label: 'Neighbor Spoofing', href: '#neighbor-spoofing-section' },
    { label: 'Search Volume', href: '#search-volume-section' },
    { label: 'Nuisance Caller', href: '#nuisance-caller-section' },
    { label: 'Comments', href: '#comments-section' },
    { label: 'Related Reports', href: '#related-reports-section' },
  ],
  vehicle: [
    {
      label: 'Vehicle Background',
      href: '#vehicle-ownership-history',
      children: [
        { label: 'Ownership History', href: '#vehicle-ownership-history' },
        { label: 'Title Records', href: '#vehicle-title-records' },
        { label: 'Title Brands', href: '#vehicle-title-brands' },
        { label: 'Liens', href: '#vehicle-liens' },
        { label: 'Impound Records', href: '#vehicle-impounds' },
        { label: 'Export Records', href: '#vehicle-exports' },
        { label: 'Specs', href: '#vehicle-specs' },
        { label: 'Detailed History', href: '#detailed-history' },
        { label: 'Sale Listings', href: '#vehicle-sales' },
        { label: 'Auctions', href: '#vehicle-auctions' },
      ],
    },
    {
      label: 'Damages & Repairs',
      href: '#vehicle-damage-history',
      children: [
        { label: 'Damage History', href: '#vehicle-damage-history' },
        { label: 'Theft Records', href: '#vehicle-thefts' },
        { label: 'Service History', href: '#vehicle-service-and-repairs' },
        { label: 'Inspections', href: '#vehicle-inspections-section' },
        {
          label: 'Maintenance Schedule',
          href: '#vehicle-maintenance-schedule',
        },
        { label: 'Recalls', href: '#vehicle-recalls' },
      ],
    },
    {
      label: 'Market & Value',
      href: '#vehicle-market',
      children: [
        { label: 'Market Values', href: '#vehicle-market' },
        { label: 'Ownership Costs', href: '#vehicle-ownership-cost' },
      ],
    },
    {
      label: 'Safety & Reliability',
      href: '#vehicle-warranty',
      children: [
        { label: 'Warranties', href: '#vehicle-warranty' },
        { label: 'Safety Ratings', href: '#vehicle-safety-ratings' },
        { label: 'Complaints', href: '#vehicle-safety-complaints-section' },
      ],
    },
  ],
  vehicle_ymm: [
    {
      label: 'Vehicle Background',
      href: '#vehicle-specs',
      children: [{ label: 'Specs', href: '#vehicle-specs' }],
    },
    {
      label: 'Damages & Repairs',
      href: '#vehicle-recalls',
      children: [{ label: 'Recalls', href: '#vehicle-recalls' }],
    },
    {
      label: 'Market & Value',
      href: '#vehicle-market',
      children: [
        { label: 'Market Values', href: '#vehicle-market' },
        { label: 'Ownership Costs', href: '#vehicle-ownership-cost' },
      ],
    },
    {
      label: 'Safety & Reliability',
      href: '#vehicle-warranty',
      children: [
        { label: 'Warranties', href: '#vehicle-warranty' },
        { label: 'Safety Ratings', href: '#vehicle-safety-ratings' },
        { label: 'Complaints', href: '#vehicle-safety-complaints-section' },
      ],
    },
  ],
  property: [
    { label: 'Possible Owners', href: '#possible-owners-section' },
    { label: 'Possible Residents', href: '#possible-residents-section' },
    { label: 'Property Details', href: '#lot-and-building-details-section' },
    { label: 'Building Permits', href: '#building-permits-section' },
    { label: 'HOA', href: '#homeowner-association-section' },
    { label: 'Taxes', href: '#assessed-value-and-taxes-section' },
    { label: 'Valuation History', href: '#property-valuation-section' },
    { label: 'Equity & Loans', href: '#equity-and-loans-section' },
    { label: 'Deeds', href: '#deeds-section' },
    { label: 'Liens', href: '#liens-section' },
    { label: 'Market Insights', href: '#market-insights' },
    { label: 'Schools', href: '#schools-nearby-section' },
    { label: 'Natural Hazards', href: '#natural-hazards-section' },
  ],
  email: [
    { label: 'FraudScan Summary', href: '#email-fraud-check-section' },
    {
      label: 'Potential Owners',
      href: '#potential-owners-section',
      children: [
        { label: 'Phone Numbers', href: '#phone-numbers-section' },
        { label: 'Email Addresses', href: '#email-section' },
        { label: 'Address History', href: '#address-history-section' },
        { label: 'Social Media', href: '#social-media-section' },
        { label: 'Data Breaches', href: '#dark-web-email-section' },
        { label: 'Jobs', href: '#jobs-section' },
        { label: 'Education', href: '#education-section' },
        { label: 'Assets', href: '#possible-owned-assets-section' },
      ],
    },
    { label: 'Related Reports', href: '#related-reports-section' },
  ],
  username: [
    {
      label: 'Potential Owners',
      href: '#potential-owners-section',
      children: [
        { label: 'Phone Numbers', href: '#phone-numbers-section' },
        { label: 'Email Addresses', href: '#email-section' },
        { label: 'Address History', href: '#address-history-section' },
        { label: 'Social Media', href: '#social-media-section' },
        { label: 'Jobs', href: '#jobs-section' },
        { label: 'Education', href: '#education-section' },
      ],
    },
    { label: 'Related Reports', href: '#related-reports-section' },
  ],
  ancestor: [
    { label: 'Overview', href: '#ancestor-overview' },
    { label: 'Facts', href: '#ancestor-facts' },
    { label: 'Relationships', href: '#ancestor-relationships' },
    { label: 'Memories', href: '#ancestor-memories' },
  ],
  obituary: [
    { label: 'Overview', href: '#obituary-overview' },
    { label: 'Full Obituary', href: '#full-obituary-section' },
    { label: 'Relatives', href: '#relatives-section' },
    { label: 'Life Events', href: '#life-events-section' },
    { label: 'Personal Interests', href: '#personal-interest-section' },
    { label: 'Funeral Details', href: '#funeral-details-section' },
  ],
};
// Report types with no entry (contact, social) render no sidenav.
